import React, { useEffect, useState } from "react";
import Layout from "../components/layout";
import { useParams } from "react-router-dom";
import MemberCard from "../components/MemberCard";
import { useNavigate } from "react-router-dom";
import { Form, Row, Col } from "antd";
import toast from "react-hot-toast";
import axios from "axios";
import "../index.css";

import picPlaceholder from "../components/people.jpg";

import { useSelector } from "react-redux";

const MemberEntryDetail = () => {
  const { matricule: encodedMatricule } = useParams();
  const matricule = decodeURIComponent(encodedMatricule);
  const [member, setMember] = useState("");
  const [familyHead, setFamilyHead] = useState(null);

  const isAfl = useSelector((state) => state.user.user?.type === "Afl");
  const isAdmin = useSelector((state) => state.user.user?.type === "Admin");
  const isUser = useSelector((state) => state.user.user?.type === "User");

  const navigate = useNavigate();

  const renderSeparator = () => (
    <React.Fragment>
      <hr style={{ border: "2px solid #005555", borderRadius: "5px" }} />
    </React.Fragment>
  );

  useEffect(() => {
    const fetchMember = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/member-detail-entry`,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
              "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify({ matricule }),
          }
        );

        const parseRes = await response.json();
        if (parseRes.success === true) {
          setMember(parseRes.data.member);
          if (!parseRes.data.member.is_family_head) {
            setFamilyHead(parseRes.data.familyHead);
          }
        } else if (parseRes.message === "NOT AUTHORIZED") {
          localStorage.clear();
          navigate("/login");
        } else {
          console.log("Member not recognized");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchMember();
  }, [matricule]);

  return (
    <Layout>
      <div className="px-5 mt-3">
        <div className="d-flex justify-content-center">
          <h3 className="page-title">Informations du patient</h3>
        </div>

        <div className="member-detail-container">
          <div key={member.matricule} className="row">
            <div className="col-md-2">
              <p className="img-container d-flex justify-content-center">
                {member.photo ? (
                  <img
                    src={`http://localhost:3000/Images/Adherants/${member?.photo}`}
                    className="member_photo_detail"
                    alt=""
                  />
                ) : (
                  <img className="member_photo_detail" src={picPlaceholder} />
                )}
              </p>
            </div>

            <div className="col-md-6">
              <p className="member-detail-name">
                {member.prenom} {member.nom}
                <td>
                  {"("}
                  {new Date(member.date_de_naissance).toLocaleDateString(
                    "fr-FR"
                  )}
                  {")"}{" "}
                  <span style={{ color: "red" }}>
                    {member.assure ? "(AD)" : "(P)"}
                  </span>
                </td>
              </p>
              <div>
                <p className="text-left-value">
                  <span className="text-left-title">Matricule: </span>
                  {member.matricule}
                </p>
                <p className="text-left-value">
                  <span className="text-left-title">Adresse: </span>
                  {!member.addresse ? "N/A" : member.addresse}
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <p className="text-left-value">
                <span className="text-left-title">Téléphone: </span>
                {!member.telephone ? "N/A" : member.telephone}
              </p>

              <p className="text-left-value">
                <span className="text-left-title">Société: </span>
                {member.societe}
              </p>

              {member.assure && (
                <p className="text-left-value">
                  <span className="text-left-title">Assuré(e) par: </span>
                  <a
                    href={`/member-detail-noms/${encodeURIComponent(
                      member.assure
                    )}`}
                  >
                    {member.assure}
                  </a>
                </p>
              )}

              {/* {!member.is_family_head && familyHead && (
                <p className="text-left-value">
                  <span className="text-left-title">Prise en charge: </span>
                  <a href={`/member-entry-detail/${familyHead.matricule}`}>
                    {familyHead.prenom} {familyHead.nom}
                  </a>
                </p>
              )} */}
            </div>
          </div>

          {/* <div className="row mt-3">
            <div className="col-md-4">
              <p className="text-left-value">
                <span className="text-left-title">Marié(e): </span>
                {member.ismarried === true ? "Oui" : "Non"}
              </p>
            </div>
            <div className="col-md-4">
              <p className="text-left-value">
                <span className="text-left-title">Patient principal: </span>
                {member.is_family_head === true ? "Oui" : "Ayant droit"}
              </p>
            </div>
            <div className="col-md-4">
              <p className="text-left-value">
                <span className="text-left-title">Enfants: </span>
                {member.haskids === true ? "Oui" : "Non"}
              </p>
            </div>
          </div> */}
        </div>

        {member.isactive === false ? (
          <div className="alert-inactif d-flex justify-content-center">
            <h1>Patient inactif</h1>
          </div>
        ) : null}
        {isUser ||
          (isAdmin && (
            <div className="member-card-detail-page">
              {renderSeparator()}
              {member && (
                <MemberCard memberData={member} key={member.matricule} />
              )}
            </div>
          ))}
      </div>
    </Layout>
  );
};

export default MemberEntryDetail;
